import script from "./PostcodeReportSearchModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./PostcodeReportSearchModal.vue?vue&type=script&lang=ts&setup=true"

import "./PostcodeReportSearchModal.vue?vue&type=style&index=0&id=355fa945&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-355fa945"]])

export default __exports__